<template>
  <div class="loading" v-if="visible">
    <div class="dialog">
      <LoadingIcon />
    </div>
  </div>
</template>

<script>
import LoadingIcon from "@/icons/LoadingIcon.vue";
export default {
  name: "Loading",
  components: {
    LoadingIcon
  },
  props: {
    visible: Boolean
  }
};
</script>

<style scoped lang="less">
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: fade(#fff, 50);
  display: block;
  z-index: 9999;
}
.dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: auto;
  height: auto;
  transition: 300ms ease-in-out transform;
  color: transparent;

  svg {
    width: 100px;
    height: 100px;
  }
}

.loadingTransition-enter-active {
  animation: fade-in 150ms;
}
.loadingTransition-leave-active {
  animation: fade-in 150ms reverse;
}

.loadingTransition-leave-active .dialog {
  transform: translate(-50%, -50%) scale(1.1);
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
